var BPM_SOUNDS_LOGO = require("./img/BPM_Sounds_Logo.svg");
var BPM_SOUNDS_LOGO_BLACK = require("./img/BPM_Sounds_Logo_Black.svg");
var DOWNLOAD_SVG = require("./img/Download_Icon_36x36.svg");
var DOWNLOAD_FILLED_SVG = require('./img/Download_Icon_Filled_36x36.svg');
var DRIVE_SVG = require("./img/Drive_Icon_36x36.svg");
var FAV_SVG = require("./img/Fav_Icon_36x36.svg");
var TRASH_SVG = require("./img/Trash_36x36.svg");
var FAV_FILLED_SVG = require("./img/Fav_Icon_Filled_36x36.svg");
var FREE_PACKS_SVG = require("./img/FreePacks_Icon_36x36.svg");
var GENRE_SVG = require("./img/Genre_Icon_36x36.svg");
var INSTRUMENTS_SVG = require("./img/Instruments_Icon_36x36.svg");
var LABELS_SVG = require("./img/labels_Icon_36x36.svg");
var LIBRARY_SVG = require("./img/Library_Icon_36x36.svg");
var MIDI_SVG = require("./img/MIDI_Icon_36x36.svg");
var MIDI_WHITE_SVG = require("./img/MIDI_Icon_White_36x36.svg");
var MIDI_FILL_SVG = require("./img/MIDI_Icon_Fill_36x36.svg");
var NEW_RELEASES_SVG = require("./img/NewReleases_Icon_36x36.svg");
var RED_NOTE_SVG = require("./img/red_note.svg");
var SEARCH_SVG = require("./img/Search_Icon_36x36.svg");
var SHARE_SVG = require("./img/share_Icon_36x36.svg");
var SUGGESTIONS_SVG = require("./img/Suggestions_Icon_36x36.svg");
var TRENDS_SVG = require("./img/Trends_Icon_36x36.svg");
var SOUNDS_LOGO_SVG = require("./img/sounds_logo.svg");
var CHEVRON_LEFT_SVG = require("./img/chevron-left.svg");
var CHEVRON_DOWN_SVG = require("./img/chevron-down.svg");
var CHEVRON_WHITE_SVG = require("./img/chevron-white.svg");
var DOWNLOAD_RED_SVG = require('./img/download-red.svg');
var LAPTOP_RED_SVG = require('./img/laptop-red.svg');
var PAPER_PLANE_RED_SVG = require('./img/paper-plane-red.svg');
var TRIANGLE_RED_SVG = require('./img/triangle-red.svg');
var TRIANGLE_DOWN = require("./img/triangle-down.svg");
var PAUSE_SVG = require("./img/pause.svg");
var PAUSE_RED_SVG = require("./img/pause_red.svg");
var RINGS_SVG = require('./img/rings.svg');
var MAGNIFY_SVG = require('./img/magnify.svg');
var PLAY_SMALL_WHITE_SVG = require('./img/play_small_white.svg');
var CHECKMARK_SVG = require('./img/checkmark.svg');
var PLUS_SVG = require('./img/plus.svg');
var VOLUME_0_SVG = require('./img/volume-0.svg');
var VOLUME_1_SVG = require('./img/volume-1.svg');
var VOLUME_2_SVG = require('./img/volume-2.svg');
var CLOSE_SVG = require('./img/close.svg');
var CHEVRON_SKINNY_SVG = require('./img/chevron-skinny.svg');
var ELLIPSES_SVG = require('./img/Ellipses.svg');
var TWITTER_SVG = require('./img/twitter.svg');
var INSTAGRAM_SVG = require('./img/instagram.svg');
var YOUTUBE_SVG = require('./img/youtube.svg');
var FACEBOOK_SVG = require('./img/facebook.svg');
var WARNING_ICON_SVG = require('./img/warning_icon.svg');
var ERROR_ICON_SVG = require('./img/error_icon.svg');
var DRIVE_BUTTON_SVG = require('./img/drive-button.svg');
var PLAYER_CLOSE_SVG = require('./img/player-close.svg');
var CREDIT_CARD_ICON_SVG = require('./img/credit-card-icon.svg');
var PLAY_BLACK_SVG = require('./img/Play_Black.svg');
var PLAY_RUBY_SVG = require('./img/Play_Ruby.svg');
var PAUSE_RUBY_SVG = require('./img/Pause_Ruby.svg');
var PLAY_WHITE_SVG = require('./img/Play_White.svg');
var CHECKBOX_CHECKED_SVG = require('./img/checkbox-checked.svg');
var STOP_RUBY_SVG = require('./img/Stop_Ruby.svg');
var PAYPAL = require('./img/ppcom.svg');
var CIRCULAR_CHECKMARK_SVG = require('./img/circular_checkmark.svg');
var PLATFORM_SVG = require('./img/platform.svg');
var BPMSUPREME_SVG = require('./img/BPM_Supreme.svg');
var BPMSUPREME_WHITE_SVG = require('./img/BPM_Supreme_white.svg');
var BPM_LATINO_LOGO_SVG = require('./img/BPM_Latino_Logo_White.svg');
var BPM_LATINO_LOGO_BLACK_SVG = require('./img/BPM_Latino_Logo_Black.svg');
var EDIT_PICTURE_SVG = require('./img/edit-picture.svg');
var EDIT_SVG = require('./img/edit.svg');
var PROFILE_PICTURE_RED = require('./img/profile_picture_red.svg');
var VERIFIED_BLUE_SVG = require('./img/verified_blue.svg');
var EYE_SVG = require('./img/eye.svg');
var SOCIAL_BLACK_FB = require('./img/social_black_fb.svg');
var SOCIAL_BLACK_LINKEDIN = require('./img/social_black_linkedin.svg');
var SOCIAL_BLACK_TWITTER = require('./img/social_black_twitter.svg');
var SOCIAL_BLACK_YT = require('./img/social_black_yt.svg');
var SUBMIT_PNG = require('./img/submit.png');
var SOCIAL_LINK = require('./img/social_link.svg');
var SOCIAL_EMAIL = require('./img/social_email.svg');
var USER_PLACEHOLDER = require('./img/userPlaceholder.jpg');
export { USER_PLACEHOLDER, SOCIAL_EMAIL, EDIT_SVG, TRASH_SVG, SOCIAL_LINK, SUBMIT_PNG, SOCIAL_BLACK_YT, SOCIAL_BLACK_TWITTER, SOCIAL_BLACK_LINKEDIN, SOCIAL_BLACK_FB, RED_NOTE_SVG, BPM_LATINO_LOGO_SVG, BPM_LATINO_LOGO_BLACK_SVG, PROFILE_PICTURE_RED, PAYPAL, BPMSUPREME_SVG, BPMSUPREME_WHITE_SVG, PLATFORM_SVG, PLAY_SMALL_WHITE_SVG, CHECKMARK_SVG, PLUS_SVG, VOLUME_0_SVG, VOLUME_1_SVG, VOLUME_2_SVG, CLOSE_SVG, BPM_SOUNDS_LOGO, MIDI_FILL_SVG, DOWNLOAD_SVG, DOWNLOAD_FILLED_SVG, DRIVE_SVG, FAV_SVG, FAV_FILLED_SVG, FREE_PACKS_SVG, GENRE_SVG, INSTRUMENTS_SVG, LABELS_SVG, LIBRARY_SVG, MIDI_SVG, MIDI_WHITE_SVG, NEW_RELEASES_SVG, SEARCH_SVG, SHARE_SVG, SUGGESTIONS_SVG, TRENDS_SVG, SOUNDS_LOGO_SVG, CHEVRON_LEFT_SVG, CHEVRON_DOWN_SVG, CHEVRON_WHITE_SVG, TRIANGLE_DOWN, PAUSE_SVG, RINGS_SVG, MAGNIFY_SVG, DOWNLOAD_RED_SVG, LAPTOP_RED_SVG, PAPER_PLANE_RED_SVG, TRIANGLE_RED_SVG, BPM_SOUNDS_LOGO_BLACK, CHEVRON_SKINNY_SVG, TWITTER_SVG, FACEBOOK_SVG, ELLIPSES_SVG, WARNING_ICON_SVG, ERROR_ICON_SVG, DRIVE_BUTTON_SVG, PLAYER_CLOSE_SVG, INSTAGRAM_SVG, YOUTUBE_SVG, CREDIT_CARD_ICON_SVG, PLAY_BLACK_SVG, PLAY_RUBY_SVG, PAUSE_RUBY_SVG, PLAY_WHITE_SVG, CHECKBOX_CHECKED_SVG, PAUSE_RED_SVG, STOP_RUBY_SVG, CIRCULAR_CHECKMARK_SVG, EDIT_PICTURE_SVG, VERIFIED_BLUE_SVG, EYE_SVG, };
//# sourceMappingURL=index.js.map